export default "__VITE_ASSET__BD2k_V4t__"